export default __webpack_public_path__ + "static/media/slack1.ed20a7df.png";